<template>
    <button
        :class="(company.favorite_status)?'btn-fav is-active':'btn-fav'"
        @click.prevent.stop="like"
    >お気に入りに追加</button>
</template>
<script setup lang="ts">
import {NaviClient} from "../../api/NaviClient";
import {NaviRequest} from "../../api/NaviRequest";
import {Storage} from "../../localstorage/Storage";
import {ref} from "vue";


const props = defineProps({
  company: {
    type: Object,
    required: true
  }
});

const emit = defineEmits(['like','unlike']);
const company = ref(props.company);

//未ログイン時はローカルストレージのお気に入り状況にする
if(!globalThis.IS_USER_LOGIN) {
  company.value.favorite_status =  Storage.isFavorite(company.value.company_id);
}

const like = () => {
  if(globalThis.IS_USER_LOGIN){
    const type = (company.value.favorite_status)? NaviRequest.DELETE: NaviRequest.STORE;
    NaviClient.favorite(company.value.company_id,type).then((json)=>{
      company.value.favorite_status = !company.value.favorite_status;
      if(company.value.favorite_status){
        emit('like',company);
      }else{
        emit('unlike',company);  
      }
    }).catch((error)=>{
      console.log(error);
    });
  }else{
    if(company.value.favorite_status){
      Storage.deleteFavorite(company.value.company_id);
      emit('unlike',company);
    }else{
      Storage.addFavorite(company.value);
      emit('like',company);
    }
    company.value.favorite_status = !company.value.favorite_status;
  }
};
</script>